module.exports = __webpack_public_path__ + "static/media/grandson-card.13938e1a.png";